import React from "react";

const ServiceList = ({ service }) => {
  return (
    <div className="col-lg-4 service-column">
      <div className="single-service text-center">
        <div className="service-icon">
          <i className={service.icon}></i>
        </div>
        <h4 className="title">{service.title}</h4>
        <p className="desc">{service.description}</p>
      </div>
    </div>
  );
};

export default ServiceList;
